import { render, staticRenderFns } from "./LPCustomerStep.vue?vue&type=template&id=03482d7a&scoped=true"
import script from "./LPCustomerStep.vue?vue&type=script&lang=ts"
export * from "./LPCustomerStep.vue?vue&type=script&lang=ts"
import style0 from "./LPCustomerStep.vue?vue&type=style&index=0&id=03482d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03482d7a",
  null
  
)

export default component.exports